import { createAction, createAsyncAction } from 'typesafe-actions';
import localForage from 'localforage';
import { Place, PlaceResponse } from './types';
import { Token } from '../users/types';
import { getMyListFromLocal, formatMyList, authFetch, unauthFetch } from '../../utils';

export const fetchPlaces = createAsyncAction(
  'places/FETCH_REQUEST',
  'places/FETCH_SUCCESS',
  'places/FETCH_FAILURE'
)<void, Place[], Error>();

export const addToListAction = createAsyncAction(
  'addToList/ADD_REQUEST',
  'addToList/ADD_SUCCESS',
  'addToList/ADD_FAILURE'
)<void, Place[], Error>();

export const getParkStatByCodeAction = createAsyncAction(
  'places/PARK_STAT_REQUEST',
  'places/PARK_STAT_SUCCESS',
  'places/PARK_STAT_FAILURE'
)<void, PlaceResponse, Error>();

export const getParkStatByCode = (parkCode: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getParkStatByCodeAction.request());
      const result = await unauthFetch(`parks/${parkCode}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      });
      if (result.status === 404) {
        dispatch(getParkStatByCodeAction.failure(new Error('Not found.')));
        return;
      }
      const res = await result.json();
      dispatch(getParkStatByCodeAction.success(res));
    });
  };
};

export const addToList = (tokens: Token, placeData: any) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(addToListAction.request());
      if (!tokens.id_token) {
        return dispatch(addToListAction.failure(new Error('You do not have permissions to add a place.')));
      }
      const { type, place } = placeData;
      return authFetch(tokens, {
        url: `users/${type}/${place.parkCode}`,
        param: {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            park_code: place.parkCode,
            park_name: place.name,
          }),
        },
      });
    });
  }
};

export const fetchAllParks = () => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(fetchPlaces.request());
      return fetch('/data/parks.min.json')
        .then(response => response.json())
        .then((json) => {
          const parkMap = {};
          json.data.forEach((item: any) => {
            parkMap[item.parkCode] = item;
          });
          dispatch(updateParkMap(JSON.stringify(parkMap)));
          dispatch(fetchPlaces.success(json.data));
        });
    });
  }
}

export const updateParkMap = createAction('places/UPDATE_PARK_MAP', resolve =>
  (parks: string) => resolve(parks)
);

export const update = createAction('places/UPDATE', resolve =>
  () => resolve()
);

export const updatePlaces = createAction('places/UPDATE_PLACE', resolve =>
  () => resolve()
);

export const setSearchTextInHome = createAction('places/SET_SEARCH_PLACE_TEXT_IN_HOME', resolve =>
  (searchPlaceText: string) => resolve(searchPlaceText)
);

export const setSearchTextInVisited = createAction('places/SET_SEARCH_TEXT_IN_VISITED', resolve =>
  (searchText: string) => resolve(searchText)
);

export const setSearchTextInBucketList = createAction('places/SET_SEARCH_TEXT_IN_BUCKET_LIST', resolve =>
  (searchText: string) => resolve(searchText)
);

export const updateTotal = createAction('places/UPDATE_TOTAL', resolve =>
  (total: number) => resolve(total)
);

export const addTagFilter = createAction('places/ADD_TAG_FILTER', resolve =>
  (trackName: string) => resolve(trackName)
);

export const removeTagFilter = createAction('places/REMOVE_TAG_FILTER', resolve =>
  (trackName: string) => resolve(trackName)
);

export const updateTagFilters = createAction('places/UPDATE_TAG_FILTERS', resolve =>
  (trackNames: string[]) => resolve(trackNames)
);

export const updateStateFilters = createAction('places/UPDATE_STATE_FILTERS', resolve =>
  (text: string[]) => resolve(text)
);
// export const addFavorite = createAction('places/ADD_FAVORITE', resolve =>
//   (placeId: string) => resolve(placeId)
// );

// export const removeFavorite = createAction('places/REMOVE_FAVORITE', resolve =>
//   (placeId: string) => resolve(placeId)
// );

export const updateFavoriteFilter = createAction('places/UPDATE_FAVORITE_FILTER', resolve =>
  (placeIds: string[]) => resolve(placeIds)
);

export const showPlacesOnDisplay = createAction('places/SHOW_PLACES_ON_DISPLAY', resolve =>
  (items: Place[]) => {
    return resolve(items);
  }
);
const NPS_URL = 'https://developer.nps.gov/api/v1';
const KEY = 'hd0FOAAs8bVbTmoq2rWGKLDCtyk3lGodivqRYy3w';

// export const getFavorites = createAsyncAction(
//   'places/GET_FAVORITES_REQUEST',
//   'places/GET_FAVORITES_SUCCESS',
//   'places/GET_FAVORITES_FAILURE'
// )<void, Place[], Error>();

// export const getFavoritePlaces = () => {
//   return (dispatch: any) => {
//     return dispatch((dispatch: any) => {
//       dispatch(getFavorites.request());
//       return localForage.getItem('favorites')
//         .then((res: any) => {
//           dispatch(getFavorites.success(res));
//         });
//     });
//   }
// }
/*****************************************************/

// export const getBucket = createAsyncAction(
//   'places/GET_BUCKET_LIST_REQUEST',
//   'places/GET_BUCKET_LIST_SUCCESS',
//   'places/GET_BUCKET_LIST_FAILURE'
// )<void, Place[], Error>();

// export const getBucketList = () => {
//   return (dispatch: any) => {
//     return dispatch((dispatch: any) => {
//       dispatch(getBucket.request());
//       // localForage.setItem('visitedPlaces', {})
//       return localForage.getItem('bucketList')
//         .then((res: any) => {
//           dispatch(getBucket.success(res));
//         });
//     });
//   }
// }
/*****************************************************/

export const getList = createAsyncAction(
  'places/GET_LIST_REQUEST',
  'places/GET_LIST_SUCCESS',
  'places/GET_LIST_FAILURE'
)<void, Place[], Error>();


export const getMyList = () => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getList.request());
      await formatMyList();
      try {
        const result = await getMyListFromLocal();
        dispatch(getList.success(result));
      } catch (e) {
        dispatch(getList.failure(new Error(e)));
      }
    });
  }
}
/*****************************************************/
// export const getMorePages = createAsyncAction(
//   'places/GET_MORE_PAGES_REQUEST',
//   'places/GET_MORE_PAGES_SUCCESS',
//   'places/GET_MORE_PAGES_FAILURE'
// )<void, Place[], Error>();

// export const searchPlaces = createAsyncAction(
//   'places/SEARCH_REQUEST',
//   'places/SEARCH_SUCCESS',
//   'places/SEARCH_FAILURE'
// )<void, Place[], Error>();

// export const getPlaces = (text: string, page: number) => {
//   return (dispatch: any) => {
//     return dispatch((dispatch: any) => {
//       if (page > 1) {
//         dispatch(getMorePages.request());
//       } else {
//         dispatch(searchPlaces.request());
//       }
//       const fields = 'images,addresses,hours,addresses,contacts,directionsInfo,directionsUrl,entranceFees,entrancePasses,latLong,operatingHours,weatherInfo';
//       const start = (page - 1) * 10 + 1
//       const queryString = '/parks?start=' + start + '&q=' + text + '&api_key=' + KEY + '&limit=10&fields=' + fields;
//       return fetch(NPS_URL + queryString)
//         .then(response => response.json())
//         .then((json) => {
//           dispatch(updateTotal(json.total));
//           if (page > 1) {
//             dispatch(getMorePages.success(json.data));
//           } else {
//             dispatch(searchPlaces.success(json.data));  
//           }
          
//         });
//     });
//   }
// };

/******************************************************/
const addTag = (tags: string[], newTag: string) => {
  const arrayTags = [...tags];
  const thisTag = newTag.toLowerCase();
  const isPresent = arrayTags.includes(thisTag);
  if (isPresent) {
    return arrayTags;
  }
  arrayTags.push(thisTag)
  return arrayTags;
}

const removeTag = (tags: string[], newTag: string) => {
  const arrayTags = [...tags];
  const thisTag = newTag.toLowerCase();
  const tagIndex = arrayTags.indexOf(thisTag);
  if (tagIndex < 0) {
    return arrayTags;
  }
  arrayTags.splice(tagIndex, 1);
  return arrayTags;
}

export const addVisited = createAsyncAction(
  'places/ADD_VISITED_REQUEST',
  'places/ADD_VISITED_SUCCESS',
  'places/ADD_VISITED_FAILURE'
)<void, Place[], Error>();

export const removeVisited = createAsyncAction(
  'places/REMOVE_VISITED_REQUEST',
  'places/REMOVE_VISITED_SUCCESS',
  'places/REMOVE_VISITED_FAILURE'
)<void, Place[], Error>();

export const addToVisitedPlaces = (places: any, place: Place) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(addVisited.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      const newTags = park.tags || [];
      const tags = addTag(newTags, 'visited');
      newplaces[id] = {
        ...park,
        tags,
      };
      localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(addVisited.success(newplaces));
        });
    });
  }
};

export const removeFromVisitedPlaces = (places: any, place: Place) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(removeVisited.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      const newTags = park.tags || [];
      const tags = removeTag(newTags, 'visited');
      newplaces[id] = {
        ...park,
        tags,
        date: '',
      };
      return localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(removeVisited.success(newplaces));
        });
    });
  }
};
/******************************************************/

export const addBucketList = createAsyncAction(
  'places/ADD_BUCKET_LIST_REQUEST',
  'places/ADD_BUCKET_LIST_SUCCESS',
  'places/ADD_BUCKET_LIST_FAILURE'
)<void, Place[], Error>();

export const removeBucketList = createAsyncAction(
  'places/REMOVE_BUCKET_LIST_REQUEST',
  'places/REMOVE_BUCKET_LIST_SUCCESS',
  'places/REMOVE_BUCKET_LIST_FAILURE'
)<void, Place[], Error>();

export const addToBucketList = (places: any, place: Place) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(addBucketList.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      const newTags = park.tags || [];
      const tags = addTag(newTags, 'bucket');
      newplaces[id] = {
        ...park,
        tags,
      };
      return localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(addBucketList.success(newplaces));
        });
    });
  }
};


export const removeFromBucketList = (places: any, place: Place) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(removeBucketList.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      const newTags = park.tags || [];
      const tags = removeTag(newTags, 'bucket');
      newplaces[id] = {
        ...park,
        tags,
      };
      return localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(removeBucketList.success(newplaces));
        });
    });
  }
};
/******************************************************/

export const addFavorite = createAsyncAction(
  'places/ADD_FAVORITE_REQUEST',
  'places/ADD_FAVORITE_SUCCESS',
  'places/ADD_FAVORITE_FAILURE'
)<void, Place[], Error>();

export const removeFavorite = createAsyncAction(
  'places/REMOVE_FAVORITE_REQUEST',
  'places/REMOVE_FAVORITE_SUCCESS',
  'places/REMOVE_FAVORITE_FAILURE'
)<void, Place[], Error>();

export const addToFavoritesList = (places: any, place: Place) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(addFavorite.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      const newTags = park.tags || [];
      const tags = addTag(newTags, 'favorites');
      newplaces[id] = {
        ...park,
        tags,
      };
      return localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(addFavorite.success(newplaces));
        });
    });
  }
};

export const removeFromFavoritesList = (places: any, place: Place) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(removeFavorite.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      const newTags = park.tags || [];
      const tags = removeTag(newTags, 'favorites');
      newplaces[id] = {
        ...park,
        tags,
      };
      return localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(removeFavorite.success(newplaces));
        });
    });
  }
};

/******************************************************/
export const updateNote = createAsyncAction(
  'places/UPDATE_NOTE_REQUEST',
  'places/UPDATE_NOTE_SUCCESS',
  'places/UPDATE_NOTE_FAILURE'
)<void, Place[], Error>();

export const updateParkNotes = (places: any, place: Place, notes: string) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(updateNote.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      newplaces[id] = {
        ...park,
        notes,
      };
      return localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(updateNote.success(newplaces));
        });
    });
  }
};
/******************************************************/
export const addDate = createAsyncAction(
  'places/ADD_DATE_REQUEST',
  'places/ADD_DATE_SUCCESS',
  'places/ADD_DATE_FAILURE'
)<void, Place[], Error>();

export const removeDate = createAsyncAction(
  'places/REMOVE_DATE_REQUEST',
  'places/REMOVE_DATE_SUCCESS',
  'places/REMOVE_DATE_FAILURE'
)<void, Place[], Error>();

export const addDateToPark = (places: any, place: Place, date: any) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(addDate.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      newplaces[id] = {
        ...park,
        date,
      };
      return localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(addDate.success(newplaces));
        });
    });
  }
};

export const removeDateFromPark = (places: any, place: Place) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(removeDate.request());
      const newplaces = { ...places };
      const { parkCode: id } = place;
      // const { id } = place;
      const park = places[id] || place;
      newplaces[id] = {
        ...park,
        date: '',
      };
      return localForage.setItem('myList', newplaces)
        .then((res) => {
          dispatch(removeDate.success(newplaces));
        });
    });
  }
};
/******************************************************/
export const fetchParkByCode = createAsyncAction(
  'places/FETCH_PARK_REQUEST',
  'places/FETCH_PARK_SUCCESS',
  'places/FETCH_PARK_FAILURE'
)<void, Place[], Error>();

export const getParkByCode = (parkCode: string) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(fetchParkByCode.request());
      // const fields = 'images,addresses,hours,addresses,contacts,directionsInfo,directionsUrl,entranceFees,entrancePasses,latLong,operatingHours,weatherInfo';
      // const queryString = '/parks?parkCode=' + parkCode + '&api_key=' + KEY + '&fields=' + fields;
      // const url = NPS_URL + queryString;
      const url = `/data/info/${parkCode}.json`; 
      return fetch(url)
        .then(response => response.json())
        .then((json) => {
          dispatch(fetchParkByCode.success(json.data));
        });
    });
  }
}
